import { useCallback, useEffect, useState } from "react";
import { PRODUCTS_FILTERS_KEY } from "app/constants";
import { parseQueries } from "app/utils/routerUtils";
import { stringify } from "qs";
import { useHistory, useLocation } from "react-router-dom";
import usePrevious from "app/utils/usePrevious";

export default (productsFilters = {}, setProductsFilters) => {
	const [filtersQueryString, setFiltersQueryString] = useState(undefined);
	const location = useLocation();
	const history = useHistory();

	const previousFiltersQueryString = usePrevious(filtersQueryString);

	const applyProductFiltersFromQueries = useCallback(query => {
		setProductsFilters(
			Object.keys(PRODUCTS_FILTERS_KEY)
				.filter(key => query[PRODUCTS_FILTERS_KEY[key]])
				.map(key => {
					return {
						key: PRODUCTS_FILTERS_KEY[key],
						value: query[PRODUCTS_FILTERS_KEY[key]],
					};
				})
		);
	}, []);

	useEffect(() => {
		const query = parseQueries(location.search);
		let filterQuery = query;

		// TODO for retrocompatibility. remove when old system is not used anymore
		if (query.filterBy) {
			filterQuery = JSON.parse(query.filterBy || "{}");

			if (filterQuery.endAt) {
				filterQuery.endAt = String(filterQuery.endAt);
			}

			if (filterQuery.startAt) {
				filterQuery.startAt = String(filterQuery.startAt);
			}

			if (filterQuery.fromPriceType) {
				filterQuery.fromPriceType = String(filterQuery.fromPriceType);
			}
		}

		// on met à jour les filtres au changement d'URL
		// notamment pour les deeplink dans les menus qui ne passent pas par le SSR
		applyProductFiltersFromQueries(filterQuery);
	}, []);

	useEffect(() => {
		const query = parseQueries(location.search);

		// remove all filter query param to handle case where a filter is removed
		Object.keys(PRODUCTS_FILTERS_KEY).forEach(key => {
			delete query[PRODUCTS_FILTERS_KEY[key]];
		});

		const queriesToApply = {
			...query,
			...productsFilters,
		};

		const stringifiedQuesriesToApply = stringify(queriesToApply);

		setFiltersQueryString(!stringifiedQuesriesToApply ? undefined : stringifiedQuesriesToApply);
	}, [productsFilters]);

	useEffect(() => {
		if (previousFiltersQueryString !== filtersQueryString) {
			history.replace({
				pathname: location.pathname,
				search: filtersQueryString,
			});
		}
	}, [filtersQueryString, previousFiltersQueryString]);
};
